function SegmentModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.segments = ctrl.resolve.segments;
  };

  ctrl.selectSegment = ($event, segment) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedSegment === segment) {
      ctrl.selectedSegment = null;
    } else {
      ctrl.selectedSegment = segment;
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.selectedSegment });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('SegmentModalController', SegmentModalController);
